/** Shorter terms match nearly everything and would only produce noise. */
export const MIN_SEARCH_TERM_LENGTH = 2;

export const MAX_RECENT_SEARCH_TERMS = 5;

export const SEARCH_DEBOUNCE_TIME_MS = 250;

export const RECENT_TERMS_STORAGE_KEY = 'spe.global-search.recent-terms';

export const GLOBAL_SEARCH_LISTBOX_ID = 'global-search-listbox';
